import React, { useState, useRef } from 'react';
import DNSItem from './DNSItem';
import loading from '../Images/loader-icon.png';

const DNSList = ({ dns, noDomains, domainCount, currentCount, fetchServer }) => {

  const [copied, setCopied] = useState(false);
  const recordsRef = useRef(null);

  let data = dns.map(obj => {
    const [key, value] = Object.entries(obj)[0];
    return <DNSItem currentCount={currentCount} domain={key} values={value} noDoamins={noDomains} />
  });

  const handleCopy = () => {
    const html = recordsRef.current.innerHTML;
    const blob = new Blob([html], { type: 'text/html' });
    const item = new ClipboardItem({ 'text/html': blob });
    navigator.clipboard.write([item]).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <>
      {dns.length > 0 ?
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <h3 style={{ margin: 0 }}>{dns.length}/{domainCount} subdomains had DNS Records</h3>
            <button className="copy-button" onClick={handleCopy}>
              {copied ? '✓ Copied!' : 'Copy Records'}
            </button>
          </div>
          <div ref={recordsRef} style={{ marginTop: '1.25rem' }}>{data}</div>
        </div>

        : <div className="loading-content">
          <h2>Searching For DNS Records, this may take several seconds...</h2>
          <h2>Found {domainCount} Subdomains</h2>
          <h3>Gathering Records<br />
            {currentCount} / {domainCount}
          </h3>
          <img src={loading} alt="loading" className="loading-icon" />
        </div>}
    </>
  );
}

export default DNSList;
